import _ from "lodash";
import { getUsers } from "@/apis/users";
import { notifyError } from "@/helpers/notification";

export const defaultStore = {
  namespaced: true, // <--- Crucial for multi-store scaling
  state: {
    users: null,
    jobOptions: null,
    vesselTypeOptions: null,
    otherServiceOptions: null,
    vesselHullModelOptions: null,
    vesselMakeOptions: null,
    vesselModelOptions: null,
    vesselBuilderOptions: null,
    vesselDocuments: [],
    defaultFormState: null,
  },
  mutations: {
    storeUsers(state, users) {
      state.users = _.cloneDeep(users);
    },
    storeJobOptions(state, jobOptions) {
      state.jobOptions = jobOptions;
    },
    storeVesselTypeOptions(state, vesselTypeOptions) {
      state.vesselTypeOptions = vesselTypeOptions;
    },
    storeOtherServiceOptions(state, otherServiceOptions) {
      state.otherServiceOptions = otherServiceOptions;
    },
    storeVesselHullModelOptions(state, vesselHullModelOptions) {
      state.vesselHullModelOptions = vesselHullModelOptions;
    },
    storeVesselMakeOptions(state, vesselMakeOptions) {
      state.vesselMakeOptions = vesselMakeOptions;
    },
    storeVesselModelOptions(state, vesselModelOptions) {
      state.vesselModelOptions = vesselModelOptions;
    },
    storeVesselBuilderOptions(state, VesselBuilderOptions) {
      state.vesselBuilderOptions = VesselBuilderOptions;
    },
    storeVesselDocuments(state, vesselDocuments, vesselId) {
      state.vesselDocuments[vesselId] = vesselDocuments;
    },
    storeDefaultFormState(state, defaultFormState) {
      state.defaultFormState = _.cloneDeep(defaultFormState);
    },
  },
  actions: {
    async retrieveUsers(ctx) {
      await getUsers()
        .then(({ data }) => {
          ctx.commit("storeUsers", data);
        })
        .catch((err) => {
          notifyError(this, err?.response?.data);
        });
    },
  },
};
